<template>
  <div class="outer">
    <b-form-radio-group size="sm" :class="{pillbox: true}" buttons button-variant="clear"
      :checked="!!value" @input="input">
      <b-form-radio :value="false"><i :class="`fas fa-${falseIcon}`"/><span class="ml-2" v-if="falseLabel">{{falseLabel}}</span></b-form-radio>
      <b-form-radio :value="true"><i :class="`fas fa-${trueIcon}`"/><span class="ml-2" v-if="trueLabel">{{trueLabel}}</span></b-form-radio>
    </b-form-radio-group>
    <slot name="trueDescription" v-if="value"></slot>
    <slot name="falseDescription" v-else></slot>
    <slot/>
  </div>
</template>

<style lang="scss" scoped>
  @import '~scss/colors';
.outer {
  display: inline-block;
  margin-right: 0.5em;
}
.btn-group > .btn-clear:first-child {
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
}
.btn-group > .btn-clear:last-child {
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
}
.btn-clear {
  border: 1px solid #ccc;
  padding: 8px 15px;
  height: auto;
  color: #aaa;
  &.active {
    color: #222;
    background: $gray-2;
  }
}

.pillbox {
  margin-top: 0.5em;
  margin-bottom: 0.5em;
}
</style>

<script>
export default {
  props: {
    value: Boolean,
    trueIcon: {type: String, default: 'check'},
    falseIcon: {type: String, default: 'times'},
    trueLabel: String,
    falseLabel: String
  },
  methods: {
    input($event) {
      this.$emit('input', $event);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/Toggle.vue